export const environment = {
  production: false,
  testEnvString: 'TestEnvironment',
  webAppUrl: 'https://propla-fx-dev-ext.axians-automated.ch/',
  apiEndPoint: 'https://propla-fx-api-dev-ext.axians-automated.ch/',
  webClientAppId: '55e39cb7-19db-42ad-b3e5-6ef92eddccfb',
  apiAppId: 'https://vesdevclub.ch/a40c3b47-460e-40db-810e-c1df35c7dd94/access_as_user',
  config: {
    tenant: 'e56c1e31-7f92-4171-93e3-362e8b7bfde3',
    clientId: '55e39cb7-19db-42ad-b3e5-6ef92eddccfb',
    redirectUri: 'https://propla-fx-dev-ext.axians-automated.ch',
    postLogoutRedirectUri: 'https://propla-fx-dev-ext.axians-automated.ch/',
    LOGGING_LEVEL: 0
  }
};